import _decorate from "@babel/runtime/helpers/esm/decorate";
let _ = t => t,
  _t,
  _t2,
  _t3;
/**
 * @license
 *
 * Copyright IBM Corp. 2020, 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */

import { html } from 'lit';
import { property } from 'lit/decorators.js';
import { ifDefined } from 'lit/directives/if-defined.js';
import settings from '@carbon/ibmdotcom-utilities/es/utilities/settings/settings.js';
import C4DLightboxMediaViewerBody from "./lightbox-media-viewer-body.js";
import "../expressive-modal/expressive-modal.js";
import "../expressive-modal/expressive-modal-close-button.js";
import { carbonElement as customElement } from '@carbon/web-components/es/globals/decorators/carbon-element.js';
const {
  stablePrefix: c4dPrefix
} = settings;

/**
 * The image content of lightbox media viewer.
 *
 * @element c4d-lightbox-image-viewer
 * @slot title - The title content.
 * @slot description - The description content.
 * @csspart container - The wrapper around the lightbox media. Usage: `c4d-lightbox-video-player::part(container)`
 * @csspart row - The wrapper around the row. Usage: `c4d-lightbox-video-player::part(row)`
 * @csspart media - The wrapper around media. Usage: `c4d-lightbox-video-player::part(media)`
 * @csspart content-wrapper - The wrapper around content. Usage: `c4d-lightbox-video-player::part(content-wrapper)`
 * @csspart content - The inner wrapper around content. Usage: `c4d-lightbox-video-player::part(content)`
 * @csspart title - The title of the media. Usage: `c4d-lightbox-video-player::part(title)`
 * @csspart description - The description of the media. Usage: `c4d-lightbox-video-player::part(description)`
 * @csspart image - The image displayed in the lightbox image viewer. Usage: `c4d-lightbox-video-player::part(image)`
 */
let C4DLightboxImageViewer = _decorate([customElement(`${c4dPrefix}-lightbox-image-viewer`)], function (_initialize, _C4DLightboxMediaView) {
  class C4DLightboxImageViewer extends _C4DLightboxMediaView {
    constructor(...args) {
      super(...args);
      _initialize(this);
    }
  }
  return {
    F: C4DLightboxImageViewer,
    d: [{
      kind: "method",
      key: "_renderDescription",
      value: function _renderDescription() {
        const {
          description
        } = this;
        return html(_t || (_t = _` <slot name="description">${0}</slot> `), description);
      }

      // eslint-disable-next-line class-methods-use-this
    }, {
      kind: "method",
      key: "_renderMedia",
      value: function _renderMedia() {
        const {
          alt,
          defaultSrc
        } = this;
        return html(_t2 || (_t2 = _`
      <img
        class="${0}--image__img"
        alt="${0}"
        src="${0}"
        loading="lazy"
        part="image" />
    `), c4dPrefix, ifDefined(alt), ifDefined(defaultSrc));
      }
    }, {
      kind: "method",
      key: "_renderTitle",
      value: function _renderTitle() {
        const {
          title
        } = this;
        return html(_t3 || (_t3 = _` <slot name="title">${0}</slot> `), title);
      }

      /**
       * The alternate text.
       */
    }, {
      kind: "field",
      decorators: [property()],
      key: "alt",
      value() {
        return '';
      }
    }, {
      kind: "field",
      decorators: [property({
        attribute: 'default-src'
      })],
      key: "defaultSrc",
      value() {
        return '';
      }
    }, {
      kind: "field",
      decorators: [property()],
      key: "description",
      value() {
        return '';
      }
    }, {
      kind: "field",
      decorators: [property()],
      key: "title",
      value() {
        return '';
      }
    }]
  };
}, C4DLightboxMediaViewerBody);
/* @__GENERATE_REACT_CUSTOM_ELEMENT_TYPE__ */
export default C4DLightboxImageViewer;
//# sourceMappingURL=lightbox-image-viewer.js.map
